import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
        <h1 className="text-8xl md:text-9xl font-heading text-background-200 select-none pointer-events-none leading-none">
          404
        </h1>
        <div className="relative z-10 -mt-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mt-6">
            Page Not Found
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            The page you are looking for does not exist or has been moved.
            Return to the Kakobuy Finds homepage to continue exploring.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-background-50 text-sm font-semibold px-6 py-3 rounded-full hover:bg-primary-400 transition-all whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            Back to Homepage
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}